// Root origin of the backend, e.g. http://localhost:5000 or https://api.meghrajcinemaz.com
// Set REACT_APP_API_BASE_URL in your frontend .env (Create React App style).
// If your project uses Vite instead, swap this for import.meta.env.VITE_API_BASE_URL.
export const API_ORIGIN = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const API_URL = `${API_ORIGIN}/api`;

// Uploaded images come back from the API either as a full Cloudinary URL, or (for
// anything uploaded before the Cloudinary migration) a relative "/uploads/xxx.jpg" path.
// For Cloudinary URLs, this also injects f_auto,q_auto (+ an optional width) so the
// browser gets an automatically-optimized, appropriately-sized image instead of the
// full-resolution original - this is the actual "loads fast" part.
export function getAssetUrl(pathOrUrl, { width } = {}) {
  if (!pathOrUrl) return '';

  if (pathOrUrl.includes('res.cloudinary.com')) {
    const transform = width ? `f_auto,q_auto,w_${width}` : 'f_auto,q_auto';
    return pathOrUrl.replace('/upload/', `/upload/${transform}/`);
  }

  if (pathOrUrl.startsWith('http')) return pathOrUrl;
  return `${API_ORIGIN}${pathOrUrl}`;
}

async function request(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      message = data.message || message;
    } catch {
      // response wasn't JSON, keep the default message
    }
    throw new Error(message);
  }

  return res.json();
}

export default request;